import React from 'react';
import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';


const StyledSelect = styled(Select)({
  '& .MuiSelect-select': {
    fontFamily: 'BuenosAires, sans-serif',
    borderRadius: '12px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'black', // Default border color
    borderRadius: '12px', // Border radius
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--dark-purple)', // Hover effect color
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--dark-purple)', // Focus color
  },
  '& .MuiInputLabel-outlined': {
    fontFamily: 'BuenosAires, sans-serif',
  },
  '& .MuiInputLabel-outlined.Mui-focused': {
    color: 'var(--dark-purple)',
  },
  '& MuiFormLabel-colorPrimary': {
    fontFamily: 'BuenosAires, sans-serif',
  },
});

export default StyledSelect;
